import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import CardTitle from "@saleor/components/CardTitle";
import RadioGroupField, {
  RadioGroupFieldChoice
} from "@saleor/components/RadioGroupField";
import { ChangeEvent } from "@saleor/hooks/useForm";
import useUser from "@saleor/hooks/useUser";
import {
  SaleType as SaleTypeEnum,
  SmopUserTypeCode
} from "@saleor/types/globalTypes";
import React from "react";
import { IntlShape, useIntl } from "react-intl";

import { SaleDetailsPageFormData } from "../SaleDetailsPage";

export interface SaleTypeProps {
  isEdit: boolean;
  data: SaleDetailsPageFormData;
  disabled: boolean;
  onChange: (event: ChangeEvent<any>) => void;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      "&&": {
        paddingBottom: theme.spacing(1.5)
      }
    }
  }),
  {
    name: "SaleType"
  }
);

function createChoices(intl: IntlShape): RadioGroupFieldChoice[] {
  return [
    {
      label: intl.formatMessage({
        defaultMessage: "Percentage",
        description: "discount type"
      }),

      value: SaleTypeEnum.PERCENTAGE
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Absolute Value",
        description: "discount type"
      }),
      value: SaleTypeEnum.ABSOLUTE_VALUE
    }
    // {
    //   label: intl.formatMessage({
    //     defaultMessage: "Fixed Amount",
    //     description: "discount type"
    //   }),
    //   value: SaleTypeEnum.FIXED
    // }
  ];
}

const SaleType: React.FC<SaleTypeProps> = props => {
  const { isEdit, data, disabled, onChange } = props;

  const classes = useStyles(props);
  const intl = useIntl();

  const choices = createChoices(intl);

  const handleChange = (
    value: any,
    onChange: (event: ChangeEvent<any>) => void
  ) => {
    if (value.target.value === "ABSOLUTE_VALUE") {
      onChange({
        target: {
          name: "description",
          value: ""
        }
      });
      onChange({
        target: {
          name: "startDate",
          value: ""
        }
      });
      onChange({
        target: {
          name: "endDate",
          value: ""
        }
      });
      onChange({
        target: {
          name: "startTime",
          value: ""
        }
      });
      onChange({
        target: {
          name: "endTime",
          value: ""
        }
      });
    }
    if (value) {
      onChange({
        target: {
          name: "type",
          value: value.target.value
        }
      });
    }
  };

  const user = useUser();
  const isSellerMaster =
    user.user?.userType.code === SmopUserTypeCode.SELLER_MASTER;
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Discount Type",
          description: "percentage or fixed, header"
        })}
      />
      <CardContent className={classes.root}>
        <RadioGroupField
          choices={choices}
          disabled={isSellerMaster && isEdit ? true : disabled}
          name={"type" as keyof SaleDetailsPageFormData}
          value={data.type}
          // onChange={onChange}
          onChange={value => handleChange(value, onChange)}
        />
      </CardContent>
    </Card>
  );
};

SaleType.displayName = "SaleType";
export default SaleType;
